import React from 'react';
import s from "./ToS.module.css"


export default function ToS() {

    return (
        <>
            <div className="WordSection1">

                <p className={s.p1}><b
                    className={s.b1}><span className={s.span1}>(для
                        представителей сторонних организаций, получающих доступ к сайту и платформе </span></b><span
                        ><b className={s.b1}><span
                            className={s.span1}>GranIoT</span></b></span><b
                                className={s.b1}><span className={s.span1}>)</span></b></p>

                <p className={s.p2}><span className={s.span1}><span
                    className={s.span2}> </span></span></p>

                <p className={s.p1}><b
                    className={s.b1}><span className={s.span1}>1. Определения</span></b></p>

                <p className={s.p2}><b className={s.b1}><span className={s.span1}>Оператор</span></b><span
                    className={s.span1}> – НПООО «ГРАН-СИСТЕМА-С», владелец веб-сайта с платформой </span><span
                    ><span className={s.span1}>GranIoT</span></span><span className={s.span1}>,
                        расположенного по адресу: </span><span className={s.span1}>https://graniot.strumen.com</span><span className={s.span1}> (далее — «Сайт»).</span></p>

                <p className={s.p2}><b className={s.b1}><span className={s.span1}>Пользователь</span></b><span
                    className={s.span1}> – сотрудник/представитель сторонней организации, получающий доступ к Сайту
                    на основании договора/поручения.</span></p>

                <p className={s.p2}><b className={s.b1}><span className={s.span1}>Платформа </span></b><span ><b
                    className={s.b1}><span className={s.span1}>GranIoT</span></b></span><span
                        className={s.span1}> - это программно-аппаратный
                        комплекс для автоматизированного сбора, обработки и визуализации данных с
                        приборов учёта с использованием технологий <span />
                        <span className={s.span1}>LoRaWAN</span></span><span
                            className={s.span1}> и </span><span className={s.span1}>NB</span><span
                                className={s.span1}>-</span><span className={s.span1}>IoT</span><span className={s.span1}>. Платформа обеспечивает прием
                                    показаний от устройств, их хранение, аналитическую обработку и предоставление
                                    результатов в удобном для потребителей виде через веб-интерфейс.</span></p>

                <p className={s.p2}><span className={s.span1}></span></p>

                <p className={s.p1}><b
                    className={s.b1}><span className={s.span1}>2. Предмет</span></b></p>

                <p className={s.p3}><span className={s.span1}>Пользователь обязуется не разглашать и
                    не использовать в личных или иных целях без письменного разрешения Оператора
                    любую информацию, ставшую ему известной при работе с Сайтом, включая, но не
                    ограничиваясь:</span></p>

                <p className={s.p4}><span className={s.span1}>• персональными данными в значении
                    Закона Республики Беларусь от 07.05.2021 №99-З «О защите персональных данных»;</span></p>

                <p className={s.p4}><span className={s.span1}>• сведениями, составляющими коммерческую
                    и/или служебную тайну Оператора;</span></p>

                <p className={s.p4}><span className={s.span1}>• технической документацией, исходными
                    кодами, отчетами, аналитикой.</span></p>

                <p className={s.p5}><span className={s.span1}><span className={s.span2}> </span></span></p>

                <p className={s.p1}><b className={s.b1}><span
                    className={s.span1}>3. Состав обрабатываемых данных</span></b></p>

                <p className={s.p3}><span className={s.span1}>Оператор может обрабатывать следующие категории информации:</span></p>

                <p className={s.p7}><span
                    className={s.span1}>3.1. Личные данные: </span></p>

                <p className={s.p8}><span className={s.span1}>• </span><span
                    className={s.span1}>адрес электронной почты (</span><span
                        className={s.span1}>email</span><span
                            className={s.span1}>);</span></p>

                <p className={s.p8}><span className={s.span1}>• </span><span
                    className={s.span1}>контактный номер телефона;</span></p>

                <p className={s.p8}><span className={s.span1}>• </span><span
                    className={s.span1}>наименование юридического лица, от
                    имени которого действует Пользователь.</span></p>

                <p className={s.p7}><span
                    className={s.span1}>3.2. Технические и автоматизировано
                    собираемые данные:</span></p>

                <p className={s.p4}><span className={s.span1}>• </span><span className={s.span1}>IP</span><span
                    className={s.span1}>-адрес, тип и
                    версия браузера;</span></p>

                <p className={s.p4}><span className={s.span1}>• </span><span className={s.span1}>временная зона, язык системы, разрешение экрана;</span></p>

                <p className={s.p4}><span className={s.span1}>• </span><span className={s.span1}>файлы </span><span className={s.span1}>cookie</span><span
                    className={s.span1}>, в том числе </span><span
                        className={s.span1}>JWT</span><span
                            className={s.span1}>-токены, используемые для обеспечения
                        сессионного доступа и аутентификации;</span></p>

                <p className={s.p4}><span className={s.span1}>• </span><span className={s.span1}>лог-файлы взаимодействия с Сайтом;</span></p>

                <p className={s.p4}><span className={s.span1}>• </span><span className={s.span1}>метаданные устройств, подключенных к платформе </span><span
                ><span className={s.span1}>GranIoT</span></span><span
                    className={s.span1}>.</span></p>

                <p className={s.p7}><span
                    className={s.span1}>3.3. Уникальные данные с устройств
                    учета:</span></p>

                <p className={s.p4}><span className={s.span1}>• </span><span className={s.span1}>показания счетчиков воды, тепла, электроэнергии;</span></p>

                <p className={s.p4}><span className={s.span1}>• </span><span className={s.span1}>идентификаторы устройств, передающих данные через </span><span
                ><span className={s.span1}>LoRa</span></span><span
                    className={s.span1}>, </span><span
                        className={s.span1}>NB</span><span
                            className={s.span1}>-</span><span className={s.span1}>IoT</span><span
                                className={s.span1}> или иные
                        протоколы беспроводной связи;</span></p>

                <p className={s.p4}><span className={s.span1}>• </span><span className={s.span1}>временные метки, параметры сигнала, статусы и иные
                    данные, необходимые для функционирования системы.</span></p>

                <p className={s.p5}><span className={s.span1}><span className={s.span2}> </span></span></p>

                <p className={s.p1}><b
                    className={s.b1}><span className={s.span1}>4. Цели обработки данных</span></b></p>

                <p className={s.p5}><span className={s.span1}>Обработка данных осуществляется исключительно для достижения следующих
                    целей:</span></p>

                <p className={s.p9}><span className={s.span1}>• </span><span
                    className={s.span1}>обеспечение функционирования Сайта и
                    платформы </span><span ><span className={s.span1}>GranIoT</span></span><span
                        className={s.span1}>;</span></p>

                <p className={s.p9}><span className={s.span1}>• </span><span
                    className={s.span1}>аутентификация и авторизация
                    Пользователей;</span></p>

                <p className={s.p4}><span className={s.span1}>• </span><span className={s.span1}>предоставление доступа к отчетам, связанным с приборами
                    учета коммунальных ресурсов;</span></p>

                <p className={s.p4}><span className={s.span1}>• </span><span className={s.span1}>формирование сводной аналитики по устройствам;</span></p>

                <p className={s.p4}><span className={s.span1}>• </span><span className={s.span1}>обеспечение взаимодействия между организациями,
                    ответственными за выставление счетов и обслуживанием приборов учета (например,
                    Водоканалы, Теплосети и т.д.).</span></p>

                <p className={s.p2}><span className={s.span1}><span
                    className={s.span2}> </span></span></p>

                <p className={s.p1}><b className={s.b1}><span
                    className={s.span1}>5. Условия и порядок хранения данных</span></b></p>

                <p className={s.p3}><span className={s.span1}>Все данные хранятся на защищенных серверах с ограниченным доступом.</span></p>

                <p className={s.p3}><span className={s.span1}>Данные не подвергаются удалению автоматически и сохраняются бессрочно, за
                    исключением случаев подачи Пользователем соответствующего запроса.</span></p>

                <p className={s.p3}><span className={s.span1}>Хранение данных осуществляется в соответствии с лучшими практиками
                    информационной безопасности, включая шифрование, аутентификацию по токенам и
                    регулярное резервное копирование.</span></p>

                <p className={s.p3}><span className={s.span1}><span className={s.span2}> </span></span></p>

                <p className={s.p1}><b className={s.b1}><span
                    className={s.span1}>6. Учетные записи и ограничение доступа</span></b></p>

                <p className={s.p3}><span className={s.span1}>Передача данных осуществляется исключительно в рамках функционирования
                    платформы </span><span ><span className={s.span1}>GranIoT</span></span><span
                        className={s.span1}>. Доступ к
                        данным получают только те юридические лица и организации, которые
                        зарегистрированы в системе и обслуживают соответствующие устройства. Каждая
                        организация имеет доступ только к своим приборам учета и их показаниям.</span></p>

                <p className={s.p3}><span className={s.span1}>Каждой зарегистрированной организации на платформе </span><span
                ><span className={s.span1}>GranIoT</span></span><span
                    className={s.span1}>
                        предоставляется учетная запись, доступ к которой может осуществляться
                        уполномоченными представителями этой организации (например, сотрудниками,
                        назначенными для работы с системой учета и отчетности).</span></p>

                <p className={s.p11}><span
                    className={s.span1}>Допускается использование одной учетной
                    записи несколькими представителями одной и той же организации при условии
                    соблюдения следующих требований:</span></p>

                <p className={s.p11}><span className={s.span1}>• </span><span className={s.span1}>доступ предоставляется только сотрудникам организации;</span></p>

                <p className={s.p11}><span className={s.span1}>• </span><span className={s.span1}>ответственность за все действия, совершенные на платформе
                    с использованием учетной записи организации, несет сама организация;</span></p>

                <p className={s.p11}><span className={s.span1}>• </span><span className={s.span1}>все пользователи, работающие под учетной записью
                    организации, обязаны соблюдать правила безопасности и конфиденциальности.</span></p>

                <p className={s.p11}><span
                    className={s.span1}>Запрещается Пользователю:</span></p>

                <p className={s.p11}><span className={s.span1}>• </span><span className={s.span1}>передавать доступ к учетной записи третьим лицам;</span><span
                    className={s.span1}> </span></p>

                <p className={s.p11}><span className={s.span1}>• использовать данные в целях,
                    отличных от прямо оговоренных целей и задач сотрудничества: </span></p>

                <p className={s.p11}><span className={s.span1}>• пытаться обойти технические
                    средства защиты (шифрование, авторизацию, журналирование). </span></p>

                <p className={s.p11}><span
                    className={s.span1}>Пользователь имеет право:</span><span
                        className={s.span1}> </span></p>

                <p className={s.p11}><span
                    className={s.span1}>• </span><span className={s.span1}><span className={s.span2}> </span>запросить уточнение, блокирование
                        или удаление данных путем обращения по </span><span className={s.span1}>e</span><span
                            className={s.span1}>-</span><span
                                className={s.span1}>mail</span><span
                                    className={s.span1}>: </span><span
                                        className={s.span1}>info@strumen.com;</span></p>

                <p className={s.p11}><span
                    className={s.span1}>• </span><span className={s.span1}>ограничить обработку данных (при технической возможности);</span><span
                        className={s.span1}> </span></p>

                <p className={s.p11}><span
                    className={s.span1}>• </span><span className={s.span1}>отозвать свое согласие на обработку данных в любое время.</span><span
                        className={s.span1}> </span></p>

                <p className={s.p7}><span
                    className={s.span1}><span className={s.span2}> </span></span></p>

                <p className={s.p1}><b
                    className={s.b1}><span className={s.span1}>7.
                        Обязательства Пользователя</span></b></p>

                <p className={s.p7}><span
                    className={s.span1}>7.1.<span className={s.span2}>  </span>Соблюдать требования Закона
                    Республики Беларусь «О защите персональных данных», Закона Республики Беларусь
                    «Об информации, информатизации и защите информации» от 10.11.2008 № 455-З и
                    иных нормативных актов.</span></p>

                <p className={s.p7}><span
                    className={s.span1}>7.2.<span className={s.span2}>    </span>Немедленно уведомлять
                    Оператора о фактах утраты, несанкционированного доступа или подозрений на такие
                    факты. </span><span className={s.span1}>В случае подозрений на несанкционированный доступ или компрометацию учетных
                        данных, Пользователь обязуется незамедлительно уведомить Оператора по адресу </span><span
                            className={s.span1}>info@strumen.com</span><span
                                className={s.span1}> для принятия
                        необходимых мер по защите информации.</span></p>

                <p className={s.p7}><span
                    className={s.span1}>7.3.<span className={s.span2}>    </span>По первому требованию
                    Оператора удалить (или вернуть) все носители/копии информации.</span></p>

                <p className={s.p7}><span
                    className={s.span1}><span className={s.span2}> </span></span></p>

                <p className={s.p1}><b
                    className={s.b1}><span className={s.span1}>8. Срок
                        действия</span></b></p>

                <p className={s.p7}><span
                    className={s.span1}>8.1.<span className={s.span2}>   </span>Настоящее Соглашение действует
                    с момента предоставления доступа и сохраняет силу в течение 10 лет после его
                    прекращения, либо дольше, если это требуется законом.</span></p>

                <p className={s.p7}><span
                    className={s.span1}>8.2.<span className={s.span2}>   </span>Обязательство по неразглашению
                    персональных данных действует бессрочно в части, необходимой для соблюдения
                    законодательства Республики Беларусь.</span></p>

                <p className={s.p7}><span
                    className={s.span1}><span className={s.span2}> </span></span></p>

                <p className={s.p1}><b
                    className={s.b1}><span className={s.span1}>9.
                        Ответственность</span></b></p>

                <p className={s.p7}><span
                    className={s.span1}>9.1.<span className={s.span2}>    </span>За нарушение Соглашения
                    Пользователь (и организация, которую он представляет) компенсирует прямые
                    убытки Оператора и несет иную ответственность, предусмотренную
                    законодательством Республики Беларусь.</span></p>

                <p className={s.p7}><span
                    className={s.span1}>9.2.<span className={s.span2}>  </span>Нарушение правил обработки
                    персональных данных влечёт административную либо уголовную ответственность.</span></p>

                <p className={s.p7}><span
                    className={s.span1}><span className={s.span2}> </span></span></p>

                <p className={s.p1}><b
                    className={s.b1}><span className={s.span1}>10. Прочие
                        условия</span></b></p>

                <p className={s.p7}><span
                    className={s.span1}>10.1.<span className={s.span2}>    </span>Все споры решаются путем
                    переговоров, при недостижении соглашения – в суде согласно подсудности.</span></p>

                <p className={s.p7}><span
                    className={s.span1}>10.2.<span className={s.span2}>    </span>Если какое-либо положение
                    признано недействительным, это не влияет на действительность остальных
                    положений.</span></p>

                <p className={s.p7}><span
                    className={s.span1}>10.3.<span className={s.span2}>    </span>Любые изменения публикуются
                    на Сайте и вступают в силу с даты публикации, для существенных изменений
                    требуется повторное согласие Пользователя.</span></p>

                <p className={s.p2}><span className={s.span1}><span
                    className={s.span2}> </span></span></p>

                <p className={s.p7}><b
                    className={s.b1}><span className={s.span1}>Нажимая кнопку
                        «Согласен» или фактически начиная работу с Сайтом, Пользователь подтверждает,
                        что прочитал, понял условия данного Соглашения и принимает их в полном объёме.</span></b></p>


            </div >

        </>
    )
}